import { stat } from 'fs';
import {

    GET_GLOBAL_REASSIGN_MODEM_REQUEST,
    GET_GLOBAL_REASSIGN_MODEM_SUCCESS,
    GET_GLOBAL_REASSIGN_MODEM_FAILURE,

    GET_GLOBAL_REASSIGN_MODEM_ACCOUNTS_REQUEST,
    GET_GLOBAL_REASSIGN_MODEM_ACCOUNTS_SUCCESS,
    GET_GLOBAL_REASSIGN_MODEM_ACCOUNTS_FAILURE,

    POST_GLOBAL_REASSIGN_MODEM_REQUEST,
    POST_GLOBAL_REASSIGN_MODEM_SUCCESS,
    POST_GLOBAL_REASSIGN_MODEM_FAILURE,

    ADD_PREVIEW_REASSIGN_MODEMS,
    REMOVE_PREVIEW_REASSIGN_MODEMS,

    SET_GLOBAL_REASSIGN_SELECTED_MODEMS,
    SET_GLOBAL_REASSIGN_SELECTED_ACCOUNT

} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    error: null,
    modems: [],
    previewModems: [],
    accountId: null,
    accounts: [],
    message: undefined,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case GET_GLOBAL_REASSIGN_MODEM_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_GLOBAL_REASSIGN_MODEM_SUCCESS:
            return {
                ...state,
                isLoading: false,
                modems: action.payload.modems,
                isInitialFetch: false,
            };
        case GET_GLOBAL_REASSIGN_MODEM_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };

        case ADD_PREVIEW_REASSIGN_MODEMS:
            return {
                ...state,
                previewModems: action.payload.modems
            };

        case REMOVE_PREVIEW_REASSIGN_MODEMS:
            return {
                ...state,
                previewModems: []
            };

        default:
            return state;
    }
};